<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Innstillinger</div>

                <v-expansion-panels focusable>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div class="subtitle-1">Søknadsinnstillinger</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <th>Navn</th>
                                        <th>Verdi</th>
                                        <th>Enhet</th>
                                        <th>Handlinger</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="setting in settings" :key="setting.original.id">
                                            <td>
                                                <div>{{getSettingName(setting.modified)}}</div>
                                            </td>
                                            <td>
                                                <v-text-field v-model="setting.modified.value" flat hide-details filled dense :rules="[v => !!v && !isNaN(v) || 'Påkrevd']">
                                                </v-text-field>
                                            </td>
                                            <td>
                                                <div>{{setting.modified.unit}}</div>
                                            </td>
                                            <td>
                                                <div class="d-flex">
                                                    <v-btn fab color="primary" x-small :disabled="!setting.isModified()" @click="setting.restore()">
                                                        <v-icon>mdi-undo</v-icon>
                                                    </v-btn>
                                                    <v-btn fab color="success" x-small class="ml-2" :disabled="!setting.canSave()" @click="setting.save()">
                                                        <v-icon>mdi-content-save</v-icon>
                                                    </v-btn>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel v-for="templateType in applicationChoiceTemplateType()" :key="templateType">
                        <v-expansion-panel-header>
                            <div class="subtitle-1">{{applicationChoiceTemplateTypeText(templateType)}}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <th>Navn</th>
                                        <th>Beskrivelse</th>
                                        <th>Type</th>
                                        <th>Handlinger</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="choice in getApplicationChoiceTemplates(templateType)" :key="choice.id">
                                            <td width="20%">
                                                <v-textarea v-model="choice.modified.name" auto-grow rows="1" hide-details flat dense filled :rules="[v => !!v || 'Påkrevd']"></v-textarea>
                                            </td>
                                            <td width="65%">
                                                <v-textarea v-model="choice.modified.description" auto-grow rows="1" hide-details flat dense filled></v-textarea>
                                            </td>
                                            <td width="10%">{{applicationChoiceTemplateTypeText(choice.modified.type)}}</td>
                                            <td width="5%">
                                                <div class="d-flex">
                                                    <v-btn fab color="primary" x-small :disabled="!choice.isModified()" @click="choice.restore()">
                                                        <v-icon>mdi-undo</v-icon>
                                                    </v-btn>
                                                    <v-btn fab color="success" x-small :disabled="!choice.isModified() || !choice.modified.name" class="ml-1" @click="updateApplicationChoiceTemplate(choice)">
                                                        <v-icon>mdi-content-save</v-icon>
                                                    </v-btn>
                                                    <v-btn fab color="error" x-small class="ml-1" @click="deleteApplicationChoiceTemplate(choice)">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </div>

                                            </td>
                                        </tr>
                                        <tr class="grey lighten-4">
                                            <td>
                                                <v-textarea v-model="newApplicationChoiceTemplate.name" placeholder="navn" auto-grow rows="1" hide-details flat dense filled></v-textarea>
                                            </td>
                                            <td>
                                                <v-textarea v-model="newApplicationChoiceTemplate.description" placeholder="beskrivelse" auto-grow rows="1" hide-details flat dense filled></v-textarea>
                                            </td>
                                            <td width="10%">{{applicationChoiceTemplateTypeText(templateType)}}</td>
                                            <td width="5%">
                                                <v-btn @click="createApplicationChoiceTemplate(newApplicationChoiceTemplate, templateType)" fab color="success" x-small :disabled="!newApplicationChoiceTemplate.name || newApplicationChoiceTemplate.name.trim().length == 0">
                                                    <v-icon>mdi-plus-circle</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import * as axios from "axios";
export default {
    data() {
        return {
            settings: [],
            applicationChoiceTemplates: [],
            selectedChoices: {},
            newApplicationChoiceTemplate: {
                name: "",
                description: "",
                type: undefined
            }
        };
    },
    methods: {
        getSettingName(setting) {
            switch (setting.name) {
                case "hourlyRate": {
                    return "Timelønn"
                }
                case "maximumDescriptionLength": {
                    return "Maksimal beskrivelse lengde";
                }
                case "startYear":{
                    return "Start år";
                }
                default:{
                    return "Ukjent innstilling"
                }
            }
        },
        getApplicationChoiceTemplates(applicationChoiceTemplateType) {
            return this.applicationChoiceTemplates.filter(t => t.original.type == applicationChoiceTemplateType);
        },

        async updateApplicationChoiceTemplate(choice) {
            let response = await axios.put("/applicationsetting/choice", { applicationChoiceTemplate: choice.modified });
            let newPreparedTemplate = this.prepareChoices([response.data])[0];
            let index = this.applicationChoiceTemplates.indexOf(choice);
            if (index > -1) {
                this.applicationChoiceTemplates.splice(index, 1, newPreparedTemplate);
            }
        },
        async deleteApplicationChoiceTemplate(choice) {
            await axios.delete(`/applicationsetting/choice/${choice.original.id}`);
            let index = this.applicationChoiceTemplates.indexOf(choice);
            if (index > -1) {
                this.applicationChoiceTemplates.splice(index, 1);
            }
        },
        async createApplicationChoiceTemplate(applicationChoiceTemplateDTO, templateType) {
            applicationChoiceTemplateDTO.type = templateType;

            let response = await axios.post("/applicationsetting/choice", { applicationChoiceTemplate: applicationChoiceTemplateDTO });
            let applicationChoiceTemplate = response.data;
            let newPreparedTemplate = this.prepareChoices([applicationChoiceTemplate])[0];
            this.applicationChoiceTemplates.push(newPreparedTemplate);

            applicationChoiceTemplateDTO.name = "";
            applicationChoiceTemplateDTO.description = "";
            applicationChoiceTemplateDTO.type = undefined;
        },
        choiceClicked(choice) {
            // console.log(choice);
            if (choice.id in this.selectedChoices) {
                this.$delete(this.selectedChoices, choice.id);
                // delete this.selectedChoices[choice.id];
            } else {
                this.$set(this.selectedChoices, choice.id, choice);
                // this.selectedChoices[choice.id] = choice;
            }
        },
        prepareChoices(templates) {
            let preparedTemplates = templates.map(act => {
                let original = act;
                let modified = {};
                Object.assign(modified, act);

                return {
                    original: original,
                    modified: modified,
                    isModified: () => {
                        if (original.name !== modified.name) {
                            return true;
                        }

                        if ((original.description === undefined || original.description === null || original.description === "") && (modified.description == undefined || modified.description == null || modified.description === "")) {
                            return false;
                        }

                        if (original.description !== modified.description) {
                            return true;
                        }

                        return false;
                        // return original.name !== modified.name || original.description !== modified.description;
                    },
                    restore: () => {
                        Object.assign(modified, original);
                    }
                };
            });
            return preparedTemplates;
        },
        prepareSettings(settings) {
            return settings.map(s => {
                let org = s;
                let mod = {};
                Object.assign(mod, org);

                return {
                    original: org,
                    modified: mod,
                    isModified: () => {
                        return org.value !== mod.value;
                    },
                    restore: () => {
                        Object.assign(mod, org);
                    },
                    canSave: () => {
                        // if(org.type === "number" && isNaN(mod.value)){
                        //     return false;
                        // }

                        return org.value !== mod.value && mod.value && !isNaN(mod.value);
                    },
                    save: async () => {
                        mod.value = mod.value.trim();
                        let response = await axios.put("/applicationSetting", { applicationSetting: mod });
                        // org = response.data;
                        Object.assign(org, response.data);
                        Object.assign(mod, org);
                    }
                };
            });
        }
    },
    async mounted() {
        let response = await axios.get("/applicationsetting");
        this.settings = this.prepareSettings(response.data);

        response = await axios.get("/applicationsetting/choice");
        let applicationChoiceTemplates = response.data;
        this.applicationChoiceTemplates = this.prepareChoices(applicationChoiceTemplates);
    }
};
</script>


<style lang="scss">
</style>